(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-arc-fan"] && !Shopify.designMode) return;
  try {
    
  class LPArcFan extends HTMLElement {
    connectedCallback() {
      this.orbits = Array.from(this.querySelectorAll('[data-lp-orbit]'));
      if (!this.orbits.length) return;
      this.n = this.orbits.length;
      this.interval = Math.max(1.5, parseFloat(this.dataset.interval || '3'));
      this.mq = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.phase = 0;
      this.running = false;
      this.raf = null;
      this.last = null;

      this.renderFrame = this.renderFrame.bind(this);
      this.onVisibility = this.onVisibility.bind(this);

      this.render(0);

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.start();
            else this.stop();
          });
        },
        { rootMargin: '-10% 0px -10% 0px', threshold: 0.2 }
      );
      this.io.observe(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.mq.addEventListener('change', () => this.render(this.phase));
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    onVisibility() {
      if (document.hidden) this.stop();
      else if (this.inView) this.start();
    }

    start() {
      this.inView = true;
      if (this.running || this.reduced.matches) return;
      this.running = true;
      this.last = null;
      this.raf = requestAnimationFrame(this.renderFrame);
    }

    stop() {
      if (this.io) this.inView = false;
      this.running = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    renderFrame(t) {
      if (!this.running) return;
      if (this.last === null) this.last = t;
      const dt = (t - this.last) / 1000;
      this.last = t;
      this.phase = (this.phase + dt / this.interval) % this.n;
      this.render(this.phase);
      this.raf = requestAnimationFrame(this.renderFrame);
    }

    render(phase) {
      const step = this.mq.matches ? 18 : 15;
      for (let i = 0; i < this.n; i += 1) {
        let rel = (i - phase) % this.n;
        if (rel > this.n / 2) rel -= this.n;
        if (rel <= -this.n / 2) rel += this.n;
        const orbit = this.orbits[i];
        orbit.style.transform = 'translateX(-50%) rotate(' + (rel * step).toFixed(3) + 'deg)';
        orbit.style.zIndex = String(i + 1);
      }
    }
  }

  if (!customElements.get('lp-arc-fan')) customElements.define('lp-arc-fan', LPArcFan);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-product-specs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.lp-spec-viz');
    if (!root) return;
    var num = function (s) { return parseFloat(s); };
    var d = root.getAttribute('data-depth') || '';
    var m = d.match(/(\d+(?:\.\d+)?)\s*(?:-|~|to)\s*(\d+(?:\.\d+)?)\s*m/i) || d.match(/(\d+(?:\.\d+)?)\s*m/i);
    if (m) {
      var lo = num(m[1]);
      var hi = m[2] !== undefined ? num(m[2]) : lo;
      if (!isNaN(lo) && !isNaN(hi) && hi <= 6) {
        var MAX = 4;
        var band = root.querySelector('[data-lp-depth-band]');
        var wrap = root.querySelector('[data-lp-depth-viz]');
        if (band && wrap) {
          var top = Math.min(lo, MAX) / MAX * 100;
          var bot = Math.min(Math.max(hi, lo + 0.15), MAX) / MAX * 100;
          band.style.top = top + '%';
          band.style.height = Math.max(bot - top, 6) + '%';
          wrap.hidden = false;
        }
      }
    }
    var L = root.getAttribute('data-length') || '';
    var lm = L.match(/(\d+(?:\.\d+)?)\s*mm/i) || L.match(/(\d+(?:\.\d+)?)\s*cm/i);
    if (lm) {
      var mm = num(lm[1]) * (/cm/i.test(lm[0]) ? 10 : 1);
      if (!isNaN(mm) && mm > 10 && mm <= 400) {
        var bar = root.querySelector('[data-lp-length-bar]');
        var lwrap = root.querySelector('[data-lp-length-viz]');
        if (bar && lwrap) {
          bar.style.width = Math.min(mm / 200 * 100, 100) + '%';
          lwrap.hidden = false;
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'lp:recent';
    var MAX_STORED = 8;
    var MAX_SHOWN = 4;

    function readStore() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    function writeStore(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {
        /* localStorage unavailable (private mode, quota) — fail silently */
      }
    }

    function recordCurrentProduct(handle) {
      if (!handle) return;
      var list = readStore().filter(function (entry) {
        return entry && entry.handle && entry.handle !== handle;
      });
      list.unshift({ handle: handle, ts: Date.now() });
      writeStore(list.slice(0, MAX_STORED));
    }

    function formatMoney(cents, formatTemplate, currency) {
      var value = cents / 100;
      var dec = value.toFixed(2);
      var noDec = Math.round(value).toString();
      var withThousands = dec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var tokens = {
        amount: withThousands,
        amount_no_decimals: noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        amount_with_comma_separator: dec.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
        amount_no_decimals_with_comma_separator: noDec.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
        amount_with_space_separator: dec.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
        amount_no_decimals_with_space_separator: noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      };
      if (formatTemplate) {
        var out = formatTemplate.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
          return tokens[key] !== undefined ? tokens[key] : m;
        });
        if (out !== formatTemplate) return out;
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return dec + ' ' + (currency || '');
      }
    }

    document.querySelectorAll('[data-lp-recently-viewed]').forEach(function (section) {
      var currentHandle = section.getAttribute('data-current-handle') || '';
      recordCurrentProduct(currentHandle);

      var grid = section.querySelector('[data-lp-recently-viewed-grid]');
      if (!grid) return;

      var formatTemplateEl = section.querySelector('[data-lp-recently-viewed-money-format]');
      var moneyFormat = formatTemplateEl ? (formatTemplateEl.getAttribute('data-format') || '').trim() : '';
      var moneyCurrency = formatTemplateEl ? (formatTemplateEl.getAttribute('data-currency') || '') : '';

      var candidates = readStore()
        .filter(function (entry) {
          return entry && entry.handle && entry.handle !== currentHandle;
        })
        .slice(0, MAX_SHOWN);

      if (candidates.length === 0) return;

      var built = 0;

      candidates.forEach(function (entry) {
        fetch('/products/' + entry.handle + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('not ok');
            return response.json();
          })
          .then(function (data) {
            if (!data || !data.available) return;

            var card = document.createElement('a');
            card.className = 'lp-recently-viewed__card';
            card.href = data.url;

            var mediaSrc = data.featured_image || (data.images && data.images[0]) || '';
            var mediaHtml = mediaSrc
              ? '<span class="lp-recently-viewed__media"><img src="' + mediaSrc + '" alt="" loading="lazy" width="500" height="500"></span>'
              : '';

            card.innerHTML =
              mediaHtml +
              '<span class="lp-recently-viewed__body">' +
              '<span class="lp-recently-viewed__title"></span>' +
              '<span class="lp-recently-viewed__price"></span>' +
              '</span>';

            card.querySelector('.lp-recently-viewed__title').textContent = data.title || '';
            var priceText = formatMoney(data.price, moneyFormat, moneyCurrency);
            if (data.price_varies) priceText = 'From ' + priceText;
            card.querySelector('.lp-recently-viewed__price').textContent = priceText;

            grid.appendChild(card);
            built += 1;
            if (built === 1) section.hidden = false;
          })
          .catch(function () {
            /* fetch failure — skip this handle silently */
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
